// client/customer/src/utils/reservations/fetchNextReservation.ts
import api from '../../lib/api';
import { ReservationSummary } from './types';

export const fetchNextReservation = async (): Promise<ReservationSummary | null> => {
  try {
    const res = await api.get<ReservationSummary>('/api/customer-app/reservation/next');
    return res.data;
  } catch (err: any) {
    if (err.response?.status === 404) {
      return null; // 次回予約なし
    }
    throw err;
  }
};
